import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { AuxJasper, ParametroJasper } from 'app/entidades/entidades';

@Component({
  selector: 'app-reimprime-recibo-agua',
  templateUrl: './reimprime-recibo-agua.component.html',
  styleUrls: ['./reimprime-recibo-agua.component.css']
})
export class ReimprimeReciboAguaComponent implements OnInit {
  public auxJasper: AuxJasper;
  anio: number;
  periodo: number;
  muestraMensaje = new MuestraMensaje();
  display: boolean = false;
  progressBar: boolean = false;
  
  constructor() { }
  
  @Input("idAguaEnvio") idAguaEnvio: number;

  async ngOnInit() 
  {
    this.limpiar();
  }

  limpiar()
  {
    this.anio = null;
    this.periodo = null;
    this.display = false;
    this.auxJasper = null;
  }

      ngOnChanges(changes: SimpleChanges): void {
       
      }

async imprimirRecibo()
  { 
    try {
      //valida
      if(this.anio == null || this.periodo == null)  throw new Error('Ingrese un año y un periodo.')

      this.progressBar = true;
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "EstadoDeCuenta";
      this.auxJasper.JasperReport.tipo = "pdf";
      
      let _id_agua = new ParametroJasper();
      _id_agua.nombre = "_id_agua";
      _id_agua.valor = this.idAguaEnvio + "";
      await this.auxJasper.ParametroJasper.push(_id_agua);

      let _anio = new ParametroJasper();
      _anio.nombre = "_anio";
      _anio.valor = this.anio + "";
      await this.auxJasper.ParametroJasper.push(_anio);
      
      let _periodo = new ParametroJasper();
      _periodo.nombre = "_periodo_parcialidad";
      _periodo.valor = this.periodo + "";
      await this.auxJasper.ParametroJasper.push(_periodo);

      let reimpresion = new ParametroJasper();
      reimpresion.nombre = "reimpresion";
      reimpresion.valor = "true";
      await this,this.auxJasper.ParametroJasper.push(reimpresion);

      let reimpresionFlag = new ParametroJasper();
      reimpresionFlag.nombre = "_reimpresion_recibo";
      reimpresionFlag.valor = "true";
      await this,this.auxJasper.ParametroJasper.push(reimpresionFlag);

      this.showDialog();

    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    }
    finally
    {
      console.log('paso por imprimirRecibo');
      this.progressBar = false;
    }
  }

  showDialog() {
    this.display = true;
  }

    }
